import { useEffect, useState, useContext} from "react";
import { ApiResponse } from "enum";
import { TiposAusenciaService } from "services/VacacionesService";
import { SecurityContext } from "context/SecurityContextProvider";

const useListarTiposAusencia = () => {
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const [tiposAusencia, setTiposAusencia] = useState([]);
	const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
	const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;
	const isPSP = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20601257280" ? true : false;
	const aprobadoresPrimerNivel = getUsuarioAutenticado().empresaSeleccionada?.colaborador?.aprobadoresPrimerNivel;
	const aprobadoresSegundoNivel = getUsuarioAutenticado().empresaSeleccionada?.colaborador?.aprobadoresSegundoNivel;

	useEffect(() => {
		const cargarDatos = async () => {
			const tiposAusencia = await TiposAusenciaService.listar();
			if (tiposAusencia.estado === ApiResponse.EXITO) {
				// Filtrar todos los que tengan permitirRegistrarMovimiento false o null (quitar los true)
				if (isSDF || isSDFEnergia) {
					const tiposFiltrados = tiposAusencia.data.filter(tipo => {
						if (tipo.permitirRegistrarMovimiento === true) return false;
						if (tipo.descripcion === "Bonificación por reemplazo" || tipo.descripcion === "Cambio de Grupo") {
							return aprobadoresPrimerNivel || aprobadoresSegundoNivel;
						}
						return true;
					});
					setTiposAusencia(tiposFiltrados);
				} else if (isPSP) {
					const tiposFiltrados = tiposAusencia.data.filter(tipo => tipo.descripcion !== "Vacaciones");
					setTiposAusencia(tiposFiltrados);
				} else {
					setTiposAusencia(tiposAusencia.data);
				}
			}
		};
		cargarDatos();
	}, []);
	return { tiposAusencia };
};

export default useListarTiposAusencia;
